import {Component, OnDestroy, OnInit} from '@angular/core';
import {NavigationEnd, Router, RouterOutlet} from '@angular/router';
import {AvisoLegalComponent} from '@components/dialogs/aviso-legal/aviso-legal.component';
import {AuthService} from '@core/services/auth.service';
import {AvisoLegalService} from '@core/services/aviso-legal.service';
import {Subscription} from 'rxjs';
import {filter} from 'rxjs/operators';
import {BreadcrumbCardComponent} from '../breadcrumb-card/breadcrumb-card.component';
import {SidebarComponent} from '../sidebar/sidebar.component';
import {ToolbarComponent} from '../toolbar/toolbar.component';

@Component({
    selector: 'app-main-layout',
    standalone: true,
    imports: [
        ToolbarComponent,
        SidebarComponent,
        RouterOutlet,
        BreadcrumbCardComponent,
        AvisoLegalComponent
    ],
    templateUrl: './main-layout.component.html',
    styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent implements OnInit, OnDestroy {
    isAuthenticated: boolean = false;
    mapMode: boolean = true;
    showAvisoLegal: boolean = false;
    private authSubscription: Subscription | null = null;
    private previousAuthState: boolean = false;

    constructor(
        private readonly authService: AuthService,
        private readonly router: Router,
        private readonly avisoLegalService: AvisoLegalService,
    ) {
    }

    ngOnInit(): void {
        this.isAuthenticated = this.authService.isAuthenticated();
        const hasRecentLogin = sessionStorage.getItem('recent_login') === 'true';
        this.previousAuthState = hasRecentLogin ? false : this.isAuthenticated;

        if (hasRecentLogin) {
            sessionStorage.removeItem('recent_login');
        }

        this.updateRouteMode(this.router.url);

        this.authSubscription = this.authService.authState$.subscribe(isAuthenticated => {
            const wasNotAuthenticated = !this.isAuthenticated;
            this.isAuthenticated = isAuthenticated;

            if (wasNotAuthenticated && isAuthenticated) {
                sessionStorage.setItem('recent_login', 'true');
            }

            this.verificarExibirAvisoLegalAposLogin();
            this.previousAuthState = isAuthenticated;
        });

        this.router.events
            .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
            .subscribe((event) => {
                this.updateRouteMode(event.urlAfterRedirects);
            });
    }

    ngOnDestroy(): void {
        if (this.authSubscription) {
            this.authSubscription.unsubscribe();
        }
    }

    private verificarExibirAvisoLegalAposLogin(): void {
        if (this.isAuthenticated && !this.previousAuthState && !this.avisoLegalService.hasShownParaAutenticado()) {
            this.showAvisoLegal = true;
            this.avisoLegalService.setShownParaAutenticado();
        }
    }

    private updateRouteMode(url: string) {
        this.mapMode = this.isCurrentRouteFullMap(url);
    }

    private isCurrentRouteFullMap(url: string): boolean {
        return url === '/' ||
            url === '/demandas/' ||
            url === '/demandas/mapa' ||
            url === '/demandas/mapa-calor' ||
            url === '/cadastro-tipo-representacao-govbr'
    }
}
